import OrganizationContent from 'components/organization';

export default OrganizationContent;
